import React from 'react';
import { FaHistory, FaSearch } from 'react-icons/fa';
import './ChangelogPanel.css';

const formatDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
};

const actorLabel = (actor) => {
  if (!actor) return 'Sistema';
  return actor.global_name || actor.username || actor.id || 'Desconhecido';
};

/**
 * Histórico de alterações do painel Admin.
 */
const ChangelogPanel = ({
  entries = [],
  total = 0,
  catalog,
  areaFilter = '',
  query = '',
  loading = false,
  onAreaFilter,
  onQueryChange,
  onSearch,
  onRefresh,
}) => {
  const areas = catalog?.areas || [];

  return (
    <section className="admin-section changelog-panel">
      <header className="admin-section__head changelog-panel__head">
        <div>
          <h1>
            <FaHistory aria-hidden="true" /> Histórico do painel
          </h1>
          <p>
            Quem alterou boas-vindas, permissões, site, VIP e outras configs
            {total != null
              ? ` · ${total} registro${total === 1 ? '' : 's'}`
              : ''}
          </p>
        </div>
        <button
          type="button"
          className="admin-btn admin-btn--ghost admin-btn--sm"
          onClick={onRefresh}
          disabled={loading}
        >
          Atualizar
        </button>
      </header>

      <div className="admin-toolbar changelog-toolbar">
        <div className="admin-filters">
          <button
            type="button"
            className={`admin-chip${!areaFilter ? ' admin-chip--active' : ''}`}
            onClick={() => onAreaFilter('')}
          >
            Todas
          </button>
          {areas.map((a) => (
            <button
              key={a.id}
              type="button"
              className={`admin-chip${areaFilter === a.id ? ' admin-chip--active' : ''}`}
              onClick={() => onAreaFilter(a.id)}
            >
              {a.label}
            </button>
          ))}
        </div>
        <form
          className="admin-search"
          onSubmit={(e) => {
            e.preventDefault();
            onSearch();
          }}
        >
          <FaSearch aria-hidden="true" />
          <input
            type="search"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            placeholder="Buscar por resumo ou autor…"
          />
        </form>
      </div>

      {loading && entries.length === 0 ? (
        <p className="admin-empty">Carregando histórico…</p>
      ) : entries.length === 0 ? (
        <p className="admin-empty">
          Nenhum registro ainda. As alterações passam a aparecer aqui após o
          próximo save.
        </p>
      ) : (
        <ol className="changelog-list">
          {entries.map((e) => (
            <li key={e.id} className="changelog-item">
              <div className="changelog-item__time">{formatDate(e.createdAt)}</div>
              <div className="changelog-item__body">
                <div className="changelog-item__top">
                  <span className={`changelog-area changelog-area--${e.area}`}>
                    {e.areaLabel || e.area}
                  </span>
                  <span className="changelog-action">{e.actionLabel || e.action}</span>
                </div>
                <p className="changelog-item__summary">{e.summary}</p>
                <p className="changelog-item__actor">
                  por <strong>{actorLabel(e.actor)}</strong>
                  {e.actor?.id ? (
                    <span className="admin-mono"> · {e.actor.id}</span>
                  ) : null}
                </p>
                {Array.isArray(e.changes) && e.changes.length > 0 && (
                  <ul className="changelog-changes">
                    {e.changes.slice(0, 6).map((c, i) => (
                      <li key={`${e.id}-${c.field}-${i}`}>
                        <code>{c.field}</code>
                        {c.from != null || c.to != null ? (
                          <span>
                            {c.from != null ? String(c.from) : '—'}
                            {' → '}
                            {c.to != null ? String(c.to) : '—'}
                          </span>
                        ) : null}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
};

export default ChangelogPanel;
